import * as Sentry from '@sentry/browser';

Sentry.init({
  debug: process.env.NODE_ENV === 'development',
  enabled: process.env.NODE_ENV === 'production',
  release: process.env.REACT_APP_SENTRY_RELEASE,
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
});

export const sentryMiddleware = (store) => (next) => (action) => {
  if (action.error) {
    Sentry.withScope((scope) => {
      scope.setExtras({
        action,
        state: store.getState(),
      });
      Sentry.captureException(action.error);
    });
  }
  return next(action);
};

export default Sentry;
